import { render, staticRenderFns } from "./reading-pen-info.vue?vue&type=template&id=d850d1c8&scoped=true&lang=pug&"
import script from "./reading-pen-info.vue?vue&type=script&lang=js&"
export * from "./reading-pen-info.vue?vue&type=script&lang=js&"
import style0 from "./reading-pen-info.vue?vue&type=style&index=0&id=d850d1c8&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d850d1c8",
  null
  
)

export default component.exports